import { render, staticRenderFns } from "./Salewindow.vue?vue&type=template&id=0205f325&scoped=true"
import script from "./Salewindow.vue?vue&type=script&lang=js"
export * from "./Salewindow.vue?vue&type=script&lang=js"
import style0 from "./Salewindow.vue?vue&type=style&index=0&id=0205f325&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205f325",
  null
  
)

export default component.exports